<template>
  <div class="white-container full-page-container common-table">
    <el-table ref="multipleTable" size="small" :data="list" style="width: 100%">
      <el-table-column prop="id" label="活动ID" width="140" fixed="left" />
      <el-table-column prop="time" label="活动日期" width="240">
        <template v-slot="{row}">
          {{ formatTime(row.startDate) }} - {{ formatTime(row.endDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="title" label="活动名称" width="200" />
      <el-table-column prop="equipmentCampImageListVOS" label="当前商品" width="auto">
        <template v-slot="{row}">
          <div class="flex">
            <template v-for="item in row.equipmentCampImageListVOS">
              <div :key="item.id">
                <img class="equiment" :src="item.imageUrl">
                <div :title="item.sku" class="sku">{{ item.sku || '--' }}</div>
              </div>
            </template>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="180">
        <template v-slot="{row}">
          <el-button size="small" type="text" class="link-color" @click="handleEdit(row)">管理关联商品</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="fixed-below" background :current-page.sync="currentPage.current" :page-sizes="currentPage.sizes" :page-size="currentPage.limit" layout="total, prev, pager, next, sizes" :total="currentPage.total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
  </div>
</template>

<script>
import moment from 'moment';
export default {
  data() {
    return {
      list: [],
      currentPage: {
        current: 1, // 当前页
        limit: 10, // 一页显示几条
        sizes: [5, 10, 20, 50, 100],
        total: 0,
      },
    };
  },
  mounted() {
    // 获取列表数据
    this.getGoodsList();
  },
  methods: {
    // 获取列表数据
    getGoodsList() {
      this.$Api.newCamp.campGoodsList({ ...this.currentPage }).then(res => {
        if (res) {
          this.list = res.data;
          this.currentPage.total = res.total;
        }
      });
    },
    // 格式化时间
    formatTime(time) {
      if (!time) return;
      return moment(time).format('YYYY/MM/DD');
    },
    // 跳转管理关联商品
    handleEdit(row) {
      this.$router.push({ path: '/equipment/meridianCamp/edit', query: { id: row.id } });
    },
    handleSizeChange(value) {
      this.currentPage.limit = value;
      this.getGoodsList();
    },
    handleCurrentChange(value) {
      this.currentPage.current = value;
      this.getGoodsList();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-table__row {
  width: 100%;
  height: 170px;
}
.flex {
  display: flex;
  align-items: center;
  > div {
    display: flex;
    flex-direction: column;
    margin-right: 50px;
    border: 1px solid #e3e3e5;
    img {
      width: 90px;
      height: 90px;
    }
    .sku {
      width: 100%;
      height: 20px;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      background: #e3e3e5;
      color: #494949;
    }
  }
}
.el-pagination {
  padding-left: 30px;
}
</style>
